import { render, staticRenderFns } from "./EventAdmin.vue?vue&type=template&id=635309ba&scoped=true"
import script from "./EventAdmin.vue?vue&type=script&lang=js"
export * from "./EventAdmin.vue?vue&type=script&lang=js"
import style0 from "./EventAdmin.vue?vue&type=style&index=0&id=635309ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635309ba",
  null
  
)

export default component.exports